module.exports = __webpack_public_path__ + "static/media/ezinne_nwankwo.7143c736.jpg";